const healthInsuranceEnum = [
  { value: 'PRIVATE', label: 'Ja' },
  { value: 'STATUTORY', label: 'Nein' }
]

export default healthInsuranceEnum
